import React, { useMemo } from 'react'
import { Box } from '@chakra-ui/react'

import {
  Line,
  XAxis,
  YAxis,
  Tooltip,
  LineChart,
  CartesianGrid,
  ResponsiveContainer
} from 'recharts'

export const LongitudinalScoreChart = ({ scores = [], loading }) => {
  const data = useMemo(
    () =>
      scores.map(({ date, score }) => ({
        date: date.toLocaleDateString(),
        score: (score * 100).toFixed()
      })),
    [scores]
  )

  return (
    <Box height='250px'>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='date' />
          <YAxis />
          <Tooltip />
          <Line
            name='Score'
            type='monotone'
            dataKey='score'
            stroke='#8884d8'
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  )
}

export default LongitudinalScoreChart
